import React from 'react';
import { pageUrlService } from '@shared/services/pageUrlService';
import RecentUpdatesNotificationCard from '../RecentUpdatesNotificationCard';

/**
 * @typedef {object} AppraisalResultNotificationProps
 * @property {Object} [notification]
 */

/**
 * @param {AppraisalResultNotificationProps} props
 */
const AppraisalResultNotification = props => {
  const { notification } = props;

  const redirectUrl = pageUrlService.getAggregateAppraisalReportPageUrl(notification.OrgUnitId);

  return (
    <RecentUpdatesNotificationCard
      name={notification.Name}
      label={'New appraisal data from ' + notification.ConductEndDate + ' is available.'}
      notificationDaysAgo={notification.NotificationDaysAgo}
      redirectUrl={redirectUrl}
    />
  );
};

export default AppraisalResultNotification;
